<template>
  <div v-if="is_recurring_settings" class="mt-8">
  <div class="my-8 border-t border-gray-300"></div>
    <div class="sm:col-span-6">
      <h3 class="text-md text-left text-black mb-2">User Recurring Settings</h3>
    </div>

    <div class="grid grid-cols-2 mb-10">
      <div
        class="text-left mt-3 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
      >
        <div class="sm:col-span-6">
          <label class="block text-sm font-medium text-gray-700">
            Recurrence Type
          </label>
          <div class="cursor-not-allowed pointer-events-none">
            <input
              type="text"
              :value="user_recurring_type"
              class="form-field-no-icon w-full"
            />
          </div>
        </div>

        <div v-if="user_recurring_is_time_period" class="sm:col-span-6">
          <label class="block text-sm font-medium text-gray-700">
            Auto-Purchase Interval (Days)
          </label>
          <div class="cursor-not-allowed pointer-events-none">
            <NumberInput type="number" v-model="user_recurring_time_period" />
          </div>
        </div>

        <div v-else class="sm:col-span-6">
          <label class="block text-sm font-medium text-gray-700">
            Auto-Purchase When Credit Balance Falls Below
          </label>
          <div class="cursor-not-allowed pointer-events-none">
            <NumberInput type="number" v-model="user_recurring_credit_limit" />
          </div>
        </div>

        <div v-if="user_recurring_is_time_period" class="sm:col-span-6">
          <label class="block text-sm font-medium text-gray-700">
            Next Payment Date
          </label>
          <div class="cursor-not-allowed pointer-events-none">
            <input
              type="text"
              :value="user_recurring_next_payment_date"
              class="form-field-no-icon w-full"
            />
          </div>
        </div>

        <div class="sm:col-span-6">
          <label class="block text-sm font-medium text-gray-700">
            Credits to Purchase
          </label>
          <div class="cursor-not-allowed pointer-events-none">
            <NumberInput
              type="number"
              v-model="user_recurring_credits_to_purchase"
            />
          </div>
          <p class="block text-sm font-bold mt-2">
            Price: ${{ formattedPrice }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberInput from "@/components/common/NumberInput";
import humanize from "humanize";

export default {
  name: "UserRecurringSettings",
  components: { NumberInput },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      user_recurring : true,
      is_recurring_settings: false,
      user_recurring_type: null,
      user_recurring_time_period: null,
      user_recurring_credit_limit: null,
      user_recurring_is_time_period: true,
      user_recurring_credits_to_purchase: null,
      user_recurring_next_payment_date: null,
      price: null,
    };
  },
  async mounted() {
    await this.fetchUserRecurringData();
  },
  async beforeUnmount() {
    await this.fetchUserRecurringData();
  },
  computed: {
    formattedPrice() {
      return humanize.numberFormat(this.price, 2);
    },
  },
  methods: {
    async fetchUserRecurringData() {
      try {        
        const response = await this.$alfredService.AdminRecurringPaymentGet(
          this.userId,
          this.user_recurring
        );
        const data = response[0];
        if (data) {
          this.is_recurring_settings = true;
          this.user_recurring_type = data.type_of_recurring;
          this.user_recurring_time_period = data.time_period;
          this.user_recurring_credit_limit = data.credit_limit;
          this.user_recurring_credits_to_purchase = data.credits_to_purchase;
          this.user_recurring_is_time_period =
            this.user_recurring_type === "Credit-Based" ? false : true;
          this.user_recurring_next_payment_date = data.next_payment_date;
          this.price = data.price;
        } else {
          this.is_recurring_settings = false;
        }
      } catch (error) {
        console.error("Error fetching user recurring data:", error);
        this.is_recurring_settings = false;
      }
    },
  },
};
</script>
